import React from 'react';
import Select from '../Select/Select';
import { RESIDENT_TYPES } from '../../constants';

const SelectResitentType = ({ ...props }) => {
  return <Select options={RESIDENT_TYPES} label={'ÐÑÐ¸Ð·Ð½Ð°Ðº ÑÐµÐ·Ð¸Ð´ÐµÐ½ÑÑÐ²Ð°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectResitentType;
